import React from 'react';
import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';

const NumberButton = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '24px',
  fontWeight: '400',
  cursor: 'pointer',
  userSelect: 'none',
  color: '#000',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '&:active': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  }
}));

const KeypadContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '1px',
  backgroundColor: '#E5E5EA',
  padding: '1px',
  borderRadius: '8px',
  '& > *': {
    backgroundColor: '#fff',
  },
  '&:first-of-type': {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  '&:last-of-type': {
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
  }
});

const DeleteButton = styled(IconButton)({
  width: '100%',
  height: '60px',
  color: '#000',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '& svg': {
    fontSize: '24px',
  }
});

const NumberPad = ({ onNumberClick, onDelete }) => {
  const handleNumberClick = (number) => {
    if (onNumberClick) {
      onNumberClick(number);
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <KeypadContainer>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
        <NumberButton
          key={number}
          onClick={() => handleNumberClick(number.toString())}
        >
          {number}
        </NumberButton>
      ))}
      <Box sx={{ backgroundColor: '#fff' }} /> {/* Empty space */}
      <NumberButton onClick={() => handleNumberClick('0')}>
        0
      </NumberButton>
      <DeleteButton onClick={handleDelete}>
        <BackspaceOutlinedIcon />
      </DeleteButton>
    </KeypadContainer>
  );
};

export default NumberPad;